import React from 'react';

const Hidden = () => (<></>);

export default Hidden;
